import styled from 'styled-components';
import { BLUE_RIBBON_400, GRAYSCALE_600, VIOLET_400 } from '../../styles/colors';
import { INTER } from '../../styles/fonts';

export const Container = (styled.div as any)`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    gap: 18px;
`;

export const IconWrapper = (styled.div as any)`
    background-color: ${BLUE_RIBBON_400};
    border-radius: 100px;
    width: 100px;
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 0.2;
`;

export const TextContainer = (styled.div as any)`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1px;
    width: 100%;
`;

export const Text = (styled.span as any)`
    padding: 0;
    margin: 0;
    font-family: ${INTER.extraLight};
    font-size: 13px;
    color: ${GRAYSCALE_600};
`;

export const PressableText = (styled.span as any)`
    padding: 0;
    margin: 0;
    font-family: ${INTER.semiBold};
    color: ${VIOLET_400};
    font-size: 13px;
    cursor: pointer;
`;
